import { LocationOrdersApiAdapter, LocationOrdersFilters } from '../adapters/LocationOrdersApiAdapter';
import { LocationOrdersModel } from '../models/LocationOrders';

export interface Page {
  locationorders: LocationOrdersModel[];
  nextPage?: number;
  hasMore: boolean;
  total: number;
}

export class Service {
  constructor(private apiAdapter: LocationOrdersApiAdapter) {}

  async getAllLocationOrders(filters: LocationOrdersFilters = {}): Promise<LocationOrdersModel[]> {
    return this.apiAdapter.getAll();
  }

  async getPaginatedLocationOrders(filters: LocationOrdersFilters = {}): Promise<Page> {
    // Sin validaciones - permite búsquedas con cualquier cantidad de caracteres
    return this.apiAdapter.getLocationOrdersPaginated(filters);
  }

  async getPaginated(filters: LocationOrdersFilters = {}): Promise<Page> {
    // Sin validaciones - permite búsquedas con cualquier cantidad de caracteres
    return this.apiAdapter.getLocationOrdersPaginated(filters);
  }
}
